<template>
  <div class="popup">
    <div class="popup__overlay error"/>
    <div class="popup__alert error">
      <div class="popup__icon-sad-error"/>
      <div class="popup__title error">
        Похоже что-то пошло не так
      </div>
      <div class="popup__text error">
        Попробуй обновить страницу и повторить то, что ты делаешь.
      </div>
      <div class="popup__text error">
	      <span>
	        А если все равно не получится - свяжись с нами тут:
	      </span>
        <span>
	        <a class="popup__error-link" href="https://t.me/vgsup_bot" target="_blank">
	           VPN Generator Support
	        </a>
	      </span>
        <span>
	         и расскажи подробно что произошло. Мы поможем:)
	      </span>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
</script>
